import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ConfigStore } from "../../store/modules/config";
import { AppErrorTypes } from "../../models/enums/appErrorTypes";
import IErrorService from "../../services/error/IErrorService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import i18n from "@/i18n";
import ISessionService from "../../services/auth/ISessionService";
import { checkVersion } from "../../utilities";
import { appConfig } from "../../config";
import Vue from "vue";

export class AppErrorVue extends Vue {
  /** Признак авторизованного клиента */
  @Prop() isAuth!: boolean;

  @Watch("technicalWorksError", { immediate: true })
  technicalWorksErrorChanged(value: boolean) {
    if (value && !this.dialog) this.setError(AppErrorTypes.TechnicalWorks);
  }

  @Watch("unexpectedError", { immediate: true })
  unexpectedErrorChanged(value: string) {
    if (value && !this.dialog)
      this.setError(AppErrorTypes.UnexpectedError, value);
  }

  @Watch("unsuppurtedBrowserError", { immediate: true })
  unsuppurtedBrowserErrorChanged(value: boolean) {
    if (value && !this.dialog) this.setError(AppErrorTypes.UnexpectedError);
  }

  @Watch("clientIsOutdatedError", { immediate: true })
  clientIsOutdatedErrorChanged(value: boolean) {
    if (value && !this.dialog) this.setError(AppErrorTypes.ClientIsOutdatedError);
  }

  /**Работы на сервере */
  get technicalWorksError(): boolean {
    return !this.configStore.apiData.State;
  }

  /**Непредвиденная ошибка */
  get unexpectedError(): string {
    return this.errorService.error;
  }

  /**Устарела версия клиента*/
  get clientIsOutdatedError(): boolean {
    return !checkVersion(this.configStore.apiData.Version, appConfig.version);
  }

  /**Непредвиденная ошибка */
  get unsuppurtedBrowserError(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();

    return (
      (/mozilla/.test(userAgent) &&
        !/firefox/.test(userAgent) &&
        !/chrome/.test(userAgent) &&
        !/safari/.test(userAgent) &&
        !/opera/.test(userAgent)) ||
      /msie/.test(userAgent)
    );
  }

  /**Заголовок ошибки */
  header: string = "";

  /**Текст ошибки */
  content: string = "";

  /**Признак видимости окна ошибки */
  dialog: boolean = false;

  /**Текст ошибки */
  errorText: string = "";

  /**Тип ошибки */
  errorType: AppErrorTypes = AppErrorTypes.None;

  /**Стор счетов */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**Сервис ошибок */
  errorService: IErrorService = container.get<IErrorService>(
    DiTokens.ErrorService
  );

  /**Сервис сессии */
  sessionService: ISessionService = container.get<ISessionService>(
    DiTokens.SessionService
  );

  /**Устанавливаем ошибку */
  setError(errorType: AppErrorTypes, errorText: string = "") {
    this.errorType = errorType;
    this.errorText = errorText;
    this.header = i18n.t(`common.errors.${this.errorType}Header`).toString();
    this.content = i18n
      .t(`common.errors.${this.errorType}Content`, { error: this.errorText })
      .toString();
    this.dialog = true;
  }

  /**Перезагрузка страницы */
  reload() {
    window.location.reload();
  }

  async logout() {
    await this.sessionService.logoutSession(true);
  }
}
